// extracted by mini-css-extract-plugin
export default {"paxtazor":"paxtazor_paxtazor__fQi1y"};